<template>
  <div class="list-container">
    <div class="list-options">
      <el-radio-group v-model="activeName" class="table-select">
        <el-radio-button tabindex="0" label="Members"></el-radio-button>
        <el-radio-button tabindex="0" label="Stations"></el-radio-button>
        <el-radio-button tabindex="0" label="Pricing"></el-radio-button>
        <el-radio-button v-if="canManageGroups" tabindex="0" label="Groups"></el-radio-button>
      </el-radio-group>

      <transition name="jump" mode="out-in">
        <members-options v-if="activeName === 'Members'" @search="search = $event" @invited="onInvited" />
        <pricing-options v-if="activeName === 'Pricing'" @search="search = $event" :organization="organization" @created="priceCreated" />
        <station-options v-if="activeName === 'Stations'" :organization="organization" @created="stationCreated" />
        <groups-options v-if="activeName === 'Groups' && canManageGroups" :organization="organization" @search="search = $event" @created="groupCreated" />
      </transition>
    </div>

    <div class="wrapper">
      <transition name="jump" mode="out-in">
        <members v-if="activeName === 'Members'" :organization="organization" :members="organization.users" :show-pending.sync="showPendingMembers" @priceCreated="priceCreated" @refresh="$emit('refresh')" :search="search" />
        <stations v-if="activeName === 'Stations'" :organization="organization" :stations="stations"/>
        <pricing v-if="activeName === 'Pricing'" :organization="organization" :prices="prices" :search="search" />
        <groups v-if="activeName === 'Groups' && canManageGroups" :organization="organization" :search="search" @refresh="$emit('refresh')" />
      </transition>
    </div>
  </div>
</template>

<script>
import Members from './Members'
import Stations from './Stations'
import Pricing from './Pricing'
import Groups from './Groups'
import MembersOptions from './Members/Options'
import PricingOptions from './Pricing/Options'
import StationOptions from './Stations/Options'
import GroupsOptions from './Groups/Options'


export default {
  name: 'ListContainer',
  components: {
    Members,
    Stations,
    Pricing,
    Groups,
    MembersOptions,
    PricingOptions,
    StationOptions,
    GroupsOptions
  },
  props: {
    organization: {
      type: Object,
      required: true
    }
  },
  watch: {
    organization () {
      this.prices = this.organization.prices
      this.stations = this.organization.stations
    },
    activeName () {
      this.search = ''
    }
  },
  data () {
    return {
      prices: this.organization.prices,
      stations: this.organization.stations,
      search: '',
      activeName: 'Members',
      showPendingMembers: false
    }
  },
  computed: {
    canManageGroups () {
      return this.$auth.user.isSystem || this.$root.isAdmin
    }
  },
  methods: {
    priceCreated (price) {
      this.prices = [...price, ...this.prices]
      this.activeName = 'Pricing'
    },
    stationCreated (station) {
      this.stations.push(station)
      this.activeName = 'Stations'
    },
    groupCreated () {
      this.activeName = 'Groups'
      this.$emit('refresh')
    },
    onInvited () {
      this.activeName = 'Members'
      this.showPendingMembers = true
      this.$emit('refresh')
    }
  }
}
</script>

<style lang="scss" scoped>
  .list-container {
    padding-right: 20px;

    @include breakpoint (xs) {
      padding: 0px;
      margin-bottom: 20px;
    }
  }

  .list-options {
    display: flex;
    justify-content: space-between;
    align-items: center;

    @include breakpoint (xs) {
      flex-direction: column;

      .table-select {
        margin-bottom: 20px;
      }
    }
  }

  .wrapper {
    margin-top: 40px;
  }
</style>



// WEBPACK FOOTER //
// src/components/dashboard/organizations/organization/lists/ListContainer.vue